<template>
  <div class="content content--sub">
    <MyHeader :breadcrumbItems="[

        {
          name: section.name,
          path: `/${$route.params.companySlug}/files`
        }
      ]"/>

    <header class="content-header">
      <h1>{{section.name}}</h1>
    </header>

    <div class="container main-content">
      <div class="section-header">
        <form class="form--oneliner">
          <div class="input-wrapper">
            <input type="text" v-model="search" placeholder="Search...">
          </div>
          <button @click.prevent><i class="icon-search"></i></button>
        </form>
      </div>
      <div class="row boxes-row" v-if="files.length">
        <div class="col-lg-4" v-for="file in files" :key="file.idFileCompany">
          <CompanyFileBox :box="file" />
        </div>
      </div>
      <div v-else class="row" style="justify-content: center;">
        <div style="display:flex; justify-content: center; flex-direction: column;">
          <img src="../assets/images/coming-soon-1.svg">
          <div>We couldn't find any files</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../components/general/Header'
import CompanyFileBox from "@/components/files/CompanyFileBox";
export default {
  name: "Files",
  components: {CompanyFileBox, MyHeader},
  data () {
    return {
      search: ''
    }
  },
  computed: {
    files() {
      if(this.search) {
        return this.$store.getters.files.filter(item => {
          return item.name.toUpperCase().includes(this.search.toUpperCase())
        })
      }
      return this.$store.getters.files
    },
    section() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'Files'
      })
    }
  },
  mounted() {
    this.$store.dispatch('getFiles', {_embed: 1})
    window._paq.push(['setDocumentTitle', this.section.name]);
    window._paq.push(['trackPageView']);
  }
}
</script>
